import { createSelector } from '@reduxjs/toolkit';
import lodashFind from 'lodash/find';

const user = (state) => state.user;

const isLoggedInSelector = createSelector(user, (state) => state.isLoggedIn);
const isGuestSelector = createSelector(user, (state) => state.user?.guest);

const requireCompleteInformationSelector = createSelector(
  user,
  (state) => state.requiringCompleteInformation,
);
const userSelector = createSelector(user, (state) => state.user);
const addressSelector = createSelector(
  userSelector,
  (user) => user?.addresses || [],
);
const activeAddressSelector = createSelector(addressSelector, (addresses) => {
  return lodashFind(addresses, { active: true });
});
const lastUsedAddressSelector = createSelector(userSelector, (user) => {
  const userAddressIds = user?.addresses?.map((address) => address.id) || [];
  return (
    user?.last_used_addresses?.filter((id) => userAddressIds.includes(id)) || []
  );
});

export {
  isLoggedInSelector,
  isGuestSelector,
  requireCompleteInformationSelector,
  userSelector,
  addressSelector,
  activeAddressSelector,
  lastUsedAddressSelector,
};
